import { translate } from "./locale";

// Map a raw backend gender value to a localized label via the shared `common`
// bundle (common.female / common.male / common.other, translated in every
// locale). Accepts English ("Female"/"male"/"F"), and already-localized ja/zh
// values so a value is never mis-bucketed into "other". Empty stays empty.
//
// Gender is display text, NOT an identifier — always render it through this
// helper, never `{user.gender}` directly. See CLAUDE.md → i18n.
const FEMALE = new Set(["female", "f", "woman", "女", "女性", "女性者"]);
const MALE = new Set(["male", "m", "man", "男", "男性", "男性者"]);

export const genderLabel = (gender) => {
  const value = String(gender ?? "")
    .trim()
    .toLowerCase();
  if (!value) return "";
  if (FEMALE.has(value) || value.startsWith("female")) {
    return translate("common", "female");
  }
  if (MALE.has(value) || value.startsWith("male")) {
    return translate("common", "male");
  }
  return translate("common", "other");
};

export default genderLabel;
